export default __webpack_public_path__ + "static/media/icon-facebook.1e9b3338.svg";